import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=127f427f&scoped=true&"
import script from "./confirmation.vue?vue&type=script&lang=js&"
export * from "./confirmation.vue?vue&type=script&lang=js&"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=127f427f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f427f",
  null
  
)

export default component.exports